<template>
  <CardLikeContainer
    :class="[$style.card, { [$style['card--concise']]: variant === 'concise' }]"
    :isActive="isActive"
  >
    <template #actions v-if="variant === 'rich'"
      ><ButtonIconOnly
        @click="emit('onCloseClicked')"
        :class="$style.card__close"
        ><template #icon><IconClose /></template></ButtonIconOnly
    ></template>
    <header :class="$style.card__heading" v-if="variant === 'rich'">
      {{ date }}
    </header>
    <section :class="$style.card__description">
      {{ startsAt }} &#12316; {{ endsAt }}
    </section>
  </CardLikeContainer>
</template>

<script lang="ts">
export const VARIANTS = ['rich', 'concise'] as const
type Variant = ValueOf<typeof VARIANTS>
</script>

<script setup lang="ts">
import IconClose from '@/components/icons/IconClose.vue'
import CardLikeContainer from '@/components/atoms/CardLikeContainer.vue'
import { computed } from 'vue'
import { type TimeSlotCardTimeSlotFragment } from './TimeSlotCard.generated'

import { format } from 'date-fns'

import { ja } from 'date-fns/locale'
import ButtonIconOnly from '@/components/atoms/ButtonIconOnly.vue'

const props = withDefaults(
  defineProps<{
    timeSlot: TimeSlotCardTimeSlotFragment
    isActive?: boolean
    variant?: Variant
  }>(),
  { isActive: false, variant: 'rich' }
)
const startsAt = computed(() =>
  format(new Date(props.timeSlot.startsAt), 'H:mm')
)
const endsAt = computed(() => format(new Date(props.timeSlot.endsAt), 'H:mm'))

const date = computed(() =>
  format(new Date(props.timeSlot.startsAt), 'Y/M/d (E)', {
    locale: ja,
  })
)
const emit = defineEmits<{ (e: 'onCloseClicked'): void }>()
</script>

<style module lang="scss">
.card {
  $root: &;

  cursor: pointer;

  &__close {
    font-size: 12px;
  }

  &__heading {
    font-size: 12px;
    font-weight: 700;
  }

  &__description {
    margin-top: 4px;
    font-size: 14px;
    font-weight: 700;
  }

  &--concise {
    & > #{$root}__description {
      margin-top: 0;
      font-size: 12px;
      font-weight: 700;
    }
  }
}
</style>
